




import { Component, Prop, Vue } from "vue-property-decorator";
import { Base64Helper } from "@/utils/base64";

@Component
export default class FileOpener extends Vue {
  @Prop() fileUrl!: string;

  public openFile() {
    const b64 = Base64Helper.toBase64(this.fileUrl);
    const url =
      window.location.origin +
      "/" +
      this.$router.resolve({
        name: "file-viewer",
        params: {}
      }).href +
      `?id=${b64}`;
    window.open(url);
  }
}
